module.exports = __webpack_public_path__ + "img/windows2019.a2d6702e.webp";